<template>
<div>
    <button v-show="!isEdit" class="button edit" @click="onEdit(true)"> 
            Edit
      </button>
      <button v-show="isEdit" class="button done" @click="onEdit(false)"> 
            Done
      </button>
    <b-field v-show="isEdit" class="edit-textarea">
            <b-input type="textarea"
                ref="editarea"
                v-model="message"
                @input="inputChanged"
                @input.native="cursorUpdate($event)"
                @keydown.native="keyPressed($event)"
                id="transcription-editor"
                placeholder="Maxlength automatically counts characters">
            </b-input>
    </b-field>
    <p v-show="!isEdit" v-selection.fix="{getSelection:getSelection}" @click="onContentClicked($event)"> 
        <Highlighter class="my-highlight"
        :highlightClassName="highlightClassName"
        :searchWords="queries[currentHighlightType].items"
        :autoEscape="true"
        :textToHighlight="message"/>
    </p>
</div>
</template>

<script>
import Highlighter from 'vue-highlight-words';
export default {
    components: {
        Highlighter
    },
    data() {
        return{
            clicks: 0,
            isEdit: false,
            delay:200,
            cursorPosition:0,
            refreshText: false,
            space: false,
            delete: false
        }
    },
    props: ['transcriptId'],
    watch:{
        "this.data.tokens":{
        handler(){
            this.getMessage();
        },
        deep:true
        }
    },
    methods:{
        getClickTokenIndex() {
            var s = window.getSelection();
            var index = -1;
            var rawHtml = this.rawHtml.trim();
            var total = 0;
            var num = ((rawHtml.substr(0, s.anchorOffset)).split('ÿ')).length - 1;

                for (var i = 0; i < this.data.tokens.length; i++) {
                    total = total + this.data.tokens[i].word.length;
                    if (total >= (s.anchorOffset - num)) {
                        index = i;
                        break;
                    }
                }

            return {index:index, position: total - (s.anchorOffset - num)};
        },
        getSelection: function(fixStr, allStr){
            this.$store.commit('selectionTextSet',allStr)
        },
        onEdit(isEdit){
            this.isEdit = isEdit;
        },
        onContentClicked(event){
            const me = this;
            me.clicks++ 
            if(me.clicks === 1 && !me.isComboKeyPressed(event)) {
                me.timer = setTimeout(function() {
                    me.onSummaryClicked(event);
                    me.clicks = 0
                }, this.delay);
            } else{
                clearTimeout(this.timer);
                me.$emit('doubleClick');
                me.clicks = 0;
            } 
        },
        isComboKeyPressed(event){
            return event.shiftKey || event.altKey || event.ctrlKey;
        },
        onSummaryClicked(event){
            var me = this;
            if (window.getSelection && (window.getSelection()).modify) {
                var s = window.getSelection();
                var rawHtml = this.rawHtml.trim();
                if (s.anchorOffset === s.focusOffset) {
                    me.onSingleClick(event, rawHtml, s);
                }
                else{
                    me.onDragClick(event, rawHtml, s);
                }
            }
        },
        onSingleClick(evt, rawHtml, s){
            var me = this;
            var index = 0;
            var total = 0;
            var num = ((rawHtml.substr(0, s.focusOffset)).split('ÿ')).length - 1;
            
            for (var i = 0; i < this.data.tokens.length; i++) {
                total = total + this.data.tokens[i].word.length;
                if (total >= (s.focusOffset - num)) {
                    index = i;
                    break;
                }
            }

            me.$emit('click', {edit: this.data.tokens[index].word, index: index, top:(evt.clientY + 5)+'px', left: (evt.clientX - 40)+'px'});
        },

         setSelectionRange(input, selectionStart, selectionEnd) {
            if (input.setSelectionRange) {
                input.focus();
                input.setSelectionRange(selectionStart, selectionEnd);
            }
            else if (input.createTextRange) {
                var range = input.createTextRange();
                range.collapse(true);
                range.moveEnd('character', selectionEnd);
                range.moveStart('character', selectionStart);
                range.select();
            }
        },

        setCaretToPos (pos) {
            this.setSelectionRange(this.$refs.editarea.$el.firstElementChild, pos, pos);
        },

        updateWordInToken(innerTokenIndex,tokenIndex, modifiedWord){
            var me = this;
            var temp = this.data.tokens[tokenIndex].word.split(' ');

            modifiedWord = modifiedWord + (me.space ? ' ':'');
            
            if(innerTokenIndex === 0 && temp.length === 1){
                    me.$emit('updateTokens', {index:tokenIndex, word: modifiedWord, transcriptId: me.transcriptId});
                }
            else{
                if(me.space){

                    temp[innerTokenIndex-1] += modifiedWord;
                }
                else{
                    temp[innerTokenIndex] = modifiedWord;
                }

                while(temp[temp.length-1] === ''){
                    temp.pop();
                }

                me.$emit('updateTokens', {index:tokenIndex, word: temp.join(' '), transcriptId: me.transcriptId});
            }
        },

        updateAllinToken(tokenIndex, modifiedWord){
            var me = this;

            me.$emit('updateTokens', {index:tokenIndex, word: modifiedWord, transcriptId: me.transcriptId});
        },

        updateWordInTokenRange(startInner, startOutter, endInner, endOutter, modifiedWord){
            var temp = this.data.tokens[startOutter].word.split(' ');
            var j = startOutter+1;

            var maxInner = (endOutter > startOutter) ? temp.length - 1 : Math.min(endInner,temp.length -1);
                    
            this.updateWordInToken(startInner,startOutter, modifiedWord);

           // for(var i = startInner+1; (endOutter > startOutter || endInner > startInner) && i < temp.length; i++){
            for(var i = startInner+1; i <= maxInner; i++){
                this.updateWordInToken(i,startOutter, '');
            }

            while(j < endOutter){
                this.updateAllinToken(j, '');
                j++;
            }

            for(var i = 0; i <= endInner && j === endOutter; i++){
                this.updateWordInToken(i,endOutter, '');
            }
        },

        updateTokens(modifiedString){
            var me = this;
            var modifiedList = modifiedString.split(' ');
            var originalList = this.message.split(' ');
            var spaceIndex = 0;
            var tokenIndex = 0;
            var innerTokenIndex = 0;
            var startIndexModified = 0;

            var endTokenIndex = this.data.tokens.length - 1;
            var endInnerTokenIndex = this.data.tokens[endTokenIndex].word.split(' ').length -1;

            var endIndexModified = 0;


            var index = me.data.tokens.length-1;
            var newWord = me.refreshText ? '˪' : '˫';

            for(var i = 0; i < modifiedList.length; i++){
                var tempList = this.data.tokens[tokenIndex].word.split(' ');
                
                if(tempList[innerTokenIndex]=== modifiedList[i]){
                    //continue
                }
                else{
                    // difference
                    startIndexModified = i;
                    break;
                }

                if(tempList.length - 1 === innerTokenIndex){
                    innerTokenIndex = 0;
                    tokenIndex++;
                }
                else{
                    innerTokenIndex++;
                }
            }

            for(var i = modifiedList.length - 1; i >= 0 ; i--){

                if(endInnerTokenIndex < 0){
                    endTokenIndex--;
                    endInnerTokenIndex = this.data.tokens[endTokenIndex].word.split(' ').length -1;
                }

                var tempList = this.data.tokens[endTokenIndex].word.split(' ');
                
                if(tempList[endInnerTokenIndex]=== modifiedList[i]){
                    //continue
                }
                else{
                    // difference
                    endIndexModified = i;
                    break;
                }

                endInnerTokenIndex--;
            }

            if(startIndexModified > endIndexModified){
                if(tokenIndex === endTokenIndex){
                    this.updateWordInTokenRange(innerTokenIndex, tokenIndex, endInnerTokenIndex, endTokenIndex, '');
                   // this.updateWordInToken(innerTokenIndex,tokenIndex, '');
                }
                else if(tokenIndex > endTokenIndex){
                    if(this.data.tokens[endTokenIndex].word === '' && me.delete){

                    }
                    else{
                        this.updateWordInToken(innerTokenIndex,endTokenIndex, this.data.tokens[endTokenIndex].word+ (modifiedList[endIndexModified]));
                    }
                }
                else{
                    // [THis]<[][][po]delete>[something]
                    this.updateWordInTokenRange(innerTokenIndex, tokenIndex, endInnerTokenIndex, endTokenIndex, '');
                }
            }
            else if(startIndexModified === endIndexModified){

                if(tokenIndex === endTokenIndex){
                    this.updateWordInTokenRange(innerTokenIndex, tokenIndex, endInnerTokenIndex, endTokenIndex, modifiedList[startIndexModified]);
                }
                else if(tokenIndex > endTokenIndex){
                    if(this.data.tokens[endTokenIndex].word === '' && me.delete){

                    }
                    else{
                    this.updateWordInToken(innerTokenIndex,endTokenIndex, this.data.tokens[endTokenIndex].word+ (modifiedList[endIndexModified]));
                    }
                }
                else{
                    // larger
                    this.updateWordInTokenRange(innerTokenIndex, tokenIndex, endInnerTokenIndex, endTokenIndex, modifiedList[startIndexModified]);
                }
            }
            else{
                // [[this<type space>is],[something]]
                me.space = false;
                me.updateWordInToken(innerTokenIndex,tokenIndex, (modifiedList[startIndexModified]+' '+modifiedList[startIndexModified+1]));
            }

            me.refreshText = !me.refreshText;
            me.$emit('updateTokens', {index:index, word: newWord, transcriptId: me.transcriptId});
        },

        onDragClick(evt, rawHtml, s){
            var me = this;
            var total = this.data.tokens.length - 1;
            var start = ((rawHtml.substr(0, s.anchorOffset)).split('ÿ')).length - 1;
            var end = ((rawHtml.substr(0, s.focusOffset)).split('ÿ')).length - 1;

            end = total === end ? end -1 : end;

            me.$emit('dragClick', {
                isHighlightModalActive: true,
                linkDialogProps:{
                    selectionText: JSON.parse(JSON.stringify(this.$store.state.selectionText)),
                    start: start,
                    end: end
                },
                filterModalPosition:{
                    top:  (evt.clientY + 5)+'px',
                    left: (evt.clientX - 40)+'px'
                }
            });
        },

        onSummaryHighlight(evt){
            if (window.getSelection && (window.getSelection()).modify && this.clicks === 1) {
                var s = window.getSelection();
                var rawHtml = this.rawHtml.trim();

                if (s.anchorOffset !== s.focusOffset) {
                    var start = ((rawHtml.substr(0, s.anchorOffset)).split('ÿ')).length - 1;
                    var end = ((rawHtml.substr(0, s.focusOffset)).split('ÿ')).length - 1;
                    this.isHighlightModalActive = true
                    this.linkDialogProps.selectionText = JSON.parse(JSON.stringify(this.$store.state.selectionText))
                    this.linkDialogProps.start = start;
                    this.linkDialogProps.end = end;
                    this.filterModalPosition.top =  (evt.clientY + 5)+'px';
                    this.filterModalPosition.left = (evt.clientX - 40)+'px';
                }
            }
        },
        inputChanged(modifiedString, ee){
            this.updateTokens(modifiedString);
        },
        cursorUpdate(event){
            var me = this;
            me.cursorPosition = event.target.selectionStart;
        },
        keyPressed(event){
            var me = this;
            if (event.keyCode == 32) {
                me.space = true;
                me.delete = false;
            }
            else if(event.keyCode === 46 || event.keyCode === 8){
                me.delete = true;
                me.space = false;
            }
            else{
                me.space = false;
                me.delete = false;
            }
        }
    },

    computed: {
        data() {
            const me = this;
            let patient = me.$store.state.patients.find(function(pTranscript){
                return pTranscript.transcriptId === me.transcriptId;
            });

            me.$store.state.modalWithDeleteItems[0].items = patient.transcript.tags || [];
            me.$store.state.modalWithDeleteItems[1].items = patient.transcript.resources || [];
            me.$store.state.modalWithDeleteItems[2].items = patient.transcript.segments || [];

            return patient.transcript
        },
        currentHighlightType() {
            return this.$store.state.currentHighlightType;
        },
        highlightClassName() {
            return "highlight-" + this.$store.state.currentHighlightType;
        },

        message:{
            get(){
                let indexCount = 0;
                let tokenCount = 0;
                let summaryText = '';
                let wordCharMapping = []; 

                this.data.tokens.forEach(function (token) {
                    while (indexCount <= token.startIndex) {
                        if (indexCount === token.startIndex) {
                            summaryText += token.word;
                            while (indexCount <= token.endIndex) {
                                wordCharMapping.push(tokenCount);
                                indexCount++;
                            }
                            indexCount = token.endIndex + 1;
                            break;
                        }
                        else {
                            summaryText += 'ÿ';
                            indexCount++;
                            wordCharMapping.push(tokenCount);
                        }
                    }

                    tokenCount++;
                })

                this.$store.commit('rawHtmlSet', summaryText)

                return summaryText.replace(/ÿ/g,' ');
            },
            set(){

            }
        },
        queries(){
            return this.$store.state.queries;
        },
        rawHtml () {
            return this.$store.state.rawHtml
        }

    },
    updated(){
        this.setCaretToPos(this.cursorPosition);
    }
}
</script>

<style scoped>

button.done,
button.edit{
    position: absolute;
    top: 0;
    margin: 0px;
    right: 0;
    background-color: #446DD8;
    color: white;
    height: 30px;
    font-size: 14px !important;
}

button.done,
button.edit:hover{
    opacity: 0.8;
}

p{
    margin:16px 0px;
}
</style>

<style>
.edit-textarea{
    margin: 16px 0px!important;
}

.edit-textarea textarea{
    font-size:16px!important;
    height:auto;
    min-height:400px!important;
    max-height:none!important;
}
</style>